const RewardProvider = require('./BaseRewardProvider');

const RewardProviderAmazon = require('./RewardProviderAmazon');

RewardProvider.Amazon = RewardProviderAmazon;

module.exports = RewardProvider;
